import { FrenchPostalCode } from "@typings/globals";

import { SelectOptionCustom } from "@ui/Atoms/Form/SelectExtended";
import { SelectOption } from "@ui/Molecules/FormikSelectExtended";

import { capitalize } from "@services/Capitalize";

const laneTypeOptions: SelectOption[] = [
  { value: "ALL", label: "Allée" },
  { value: "AV", label: "Avenue" },
  { value: "BAT", label: "Batiment" },
  { value: "BD", label: "Boulevard" },
  { value: "C", label: "Cours" },
  { value: "CAN", label: "Canal" },
  { value: "CHE", label: "Chemin" },
  { value: "CHS", label: "Chaussée" },
  { value: "CI", label: "Cité" },
  { value: "CL", label: "Clos" },
  { value: "COG", label: "Cottage" },
  { value: "FG", label: "Faubourg" },
  { value: "HAM", label: "Hameau" },
  { value: "IMB", label: "Immeuble" },
  { value: "IMP", label: "Impasse" },
  { value: "LOT", label: "Lotissement" },
  { value: "MAI", label: "Maison" },
  { value: "MTE", label: "Montée" },
  { value: "PAR", label: "Parc" },
  { value: "PAS", label: "Passage" },
  { value: "PAV", label: "Pavillon" },
  { value: "PL", label: "Place" },
  { value: "POR", label: "Porte" },
  { value: "Q", label: "Quai" },
  { value: "QU", label: "Quartier" },
  { value: "R", label: "Rue" },
  { value: "RAM", label: "Rampe" },
  { value: "RES", label: "Résidence" },
  { value: "RTE", label: "Route" },
  { value: "RUL", label: "Ruelle" },
  { value: "SEN", label: "Sentier" },
  { value: "SQ", label: "Square" },
  { value: "VO", label: "Voie" },
];

const laneLetterTypeOptions: SelectOption[] = [
  { value: "B", label: "B" },
  { value: "T", label: "T" },
  { value: "Q", label: "Q" },
  { value: "C", label: "C" },
];

const getPostalCodeOptions = (
  postalCodes: FrenchPostalCode[],
): SelectOptionCustom[] =>
  postalCodes.map(code => ({
    value: code.inseeCode,
    label: `${code.postalCode} ${capitalize(code.communeName)}`,
    extraLabel: code.inseeCode,
  }));

export { laneTypeOptions, laneLetterTypeOptions, getPostalCodeOptions };
